export function PageNotFound() {
	return <div>Page not found</div>;
}
